import { Component, Inject } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { IBillingShippingModel } from "../../../../interfaces/LicenseModel";
import { LicenseService } from "../../../../services/LicenseService";
import { AdalService } from "../../../../shared/adal.service";
import { AppLoaderService } from "../../../../../services/app-loader/app-loader.service";
import * as constants from "../../constants";

@Component({
  selector: "addmore-syncit-license",
  styles: [require('./addmore-syncit-license.component.css')],
  template: require('./addmore-syncit-license.component.html'),
})
export class AddMoreSyncItLicenseComponent {
  billingShippingDetail: IBillingShippingModel = {
    ODataEtag: "",
    Number: "",
    publicId: "",
    CustomerNo: "",
    publicSalesPersoncode: "",
    BillToName: "",
    BillToAddress1: "",
    BillToAddress2: "",
    BillToCity: "",
    BillToState: "",
    BillToZipcode: "",
    BillToCountryCode: "",
    ShipToCode: "",
    ShipToName: "",
    ShipToAddress1: "",
    ShipToAddress2: "",
    ShipToCity: "",
    ShipToState: "",
    ShipToZipcode: "",
    ShipToCountryCode: "",
    CustomerTelephone: "",
    CustomerEmailAddress: "",
    CustomerFaxno: "",
    ShippingTelephoneno: "",
    ShippingFaxno: "",
    ShippingEmailAddress: "",
    Rep1: "",
    Rep2: "",
    Sales1: "",
    Sales2: "",
  };

  isBillingShippingDetailFetched = false;
  licenseType: string;
  submitted: boolean = false;
  customerId = 0;
  shippingAddressId = 0;
  shouldFetchSalesOrderNo = false;
  SyncItLicenseList: any;
  syncITLicenseForm: FormGroup;
  errorMessage = "";
  MAX_TRIAL_INSTRUMENTS = constants.MAX_TRIAL_INSTRUMENTS;
  error = "";
  isLoading = false;
  syncItproductList: any;
  dialogTitle: any;
  prevSalesOrderNo = "";
  SyncITProductLicenseId: number;
  constructor(
    private dialogRef: MdDialogRef<AddMoreSyncItLicenseComponent>,
    private formBuilder: FormBuilder,
    private licenseService: LicenseService,
    private appLoader: AppLoaderService,
    private snackBar: MdSnackBar,
    private adalService: AdalService,
    private router: Router,
    @Inject(MD_DIALOG_DATA) public dialogData: any,
  ) {
    if (!this.adalService.getCachedToken()) {
      this.dialogRef.close(null);
      this.router.navigate(["login"]);
    }
    this.buildForm();
    this.dialogTitle = "Add More SyncIT License";

    this.SyncITProductLicenseId = this.dialogData.SyncITProductLicenseId;
    this.licenseType = this.dialogData.LicenseType;
    this.fetchSyncITLicenseDetails(this.SyncITProductLicenseId);
  }

  buildForm() {
    this.syncITLicenseForm = this.formBuilder.group({
      SalesOrderNo: ["", [Validators.required]],
      Products: this.formBuilder.array([]),
    });
  }

  blurSalesOrderEvent() {
    if (
      this.prevSalesOrderNo.trim().toUpperCase() ==
      this.syncITLicenseForm.value.SalesOrderNo.trim().toUpperCase()
    ) {
      return;
    }
    this.prevSalesOrderNo = this.syncITLicenseForm.value.SalesOrderNo;
    setTimeout(() => {
      this.shouldFetchSalesOrderNo = true;
      this.isBillingShippingDetailFetched = false;
    }, 150);
  }

  fetchSyncITLicenseDetails(licenseId: number) {
    if (!licenseId) return;

    this.appLoader.open();

    this.licenseService.getSyncITLicensePurchaseProduct(licenseId).subscribe(
      (res: any) => {
        this.appLoader.close();

        const productFormGroups = res.DataObject.map((product) =>
          this.formBuilder.group({
            ProductId: [product.SyncItProductId],
            ProductName: [product.SyncItProductName],
            NoOfProductLicense: [product.NoOfProductLicense],
            NoOfLicense: [0, Validators.min(0)],
          }),
        );
        const productsFormArray: FormArray = this.syncITLicenseForm.get(
          "Products",
        ) as FormArray;

        productFormGroups.forEach((fg) => productsFormArray.push(fg));

        productsFormArray.updateValueAndValidity();
        // Ensure FormArray exists
      },
      (err) => {
        this.appLoader.close();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while fetching license data.",
          confirmButtonText: "Ok",
          confirmButtonColor: "#FFCA28",
        });
      },
    );
  }

  get productsFormArray(): FormArray {
    return this.syncITLicenseForm.get("Products") as FormArray;
  }

  checkSalesOrderNo() {
    if (this.dialogData.SyncItLicenseList) {
      let exist = this.dialogData.SyncItLicenseList.some((element) => {
        if (element.SalesOrderNo != null) {
          return (
            this.syncITLicenseForm.value.SalesOrderNo.trim().toUpperCase() ==
            element.SalesOrderNo.trim().toUpperCase()
          );
        } else {
          return false;
        }
      });

      if (exist) {
        Swal.fire({
          title: "This sales order no already exists",
          text: "Are you sure you want to use this Sales Order No?",
          showCancelButton: true,
          showCloseButton: true,
          showConfirmButton: true,
          confirmButtonText: "Yes",
          confirmButtonColor: "#FFCA28",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
            this.shouldFetchSalesOrderNo = true;
            this.isBillingShippingDetailFetched = false;
            this.getBillingShippingDetail();
          } else {
            this.shouldFetchSalesOrderNo = false;
            this.syncITLicenseForm.patchValue({
              SalesOrderNo: "",
            });
          }
        });
      } else {
        this.shouldFetchSalesOrderNo = true;
        this.isBillingShippingDetailFetched = false;
        this.getBillingShippingDetail();
      }
    } else {
      this.shouldFetchSalesOrderNo = true;
      this.isBillingShippingDetailFetched = false;
      this.getBillingShippingDetail();
    }
  }

  getBillingShippingDetail() {
    let salesOrderNo = this.syncITLicenseForm.value.SalesOrderNo;
    if (salesOrderNo != "") {
      if (this.shouldFetchSalesOrderNo) {
        this.appLoader.open();
        this.licenseService
          .getBillingShippingDetail(salesOrderNo)
          .subscribe((data) => {
            if (!data.IsError && data.DataObject != null) {
              this.billingShippingDetail = data.DataObject;
              this.isBillingShippingDetailFetched = true;
              this.error = "";
            } else {
              this.isBillingShippingDetailFetched = false;
              this.error = data.Error;
            }
            this.appLoader.close();
          });
      } else {
        this.error = "Please select other sales order number.";
      }
    } else {
      this.error = "Sales Order No is required";
      this.isBillingShippingDetailFetched = false;
    }
  }
  onSave() {
    const formValue = this.syncITLicenseForm.getRawValue();

    const totalLicenses = formValue.Products.reduce(
      (sum: number, p: any) => sum + (Number(p.NoOfLicense) || 0),
      0,
    );

    if (totalLicenses === 0) {
      Swal.fire({
        icon: "warning",
        title: "No License Selected",
        text: "Please purchase at least one instrument license before saving.",
        confirmButtonText: "Ok",
        confirmButtonColor: "#FFCA28",
      });
      return; // Stop saving
    }

    if (this.licenseType == "Trial") {
      const totalLicenses = formValue.Products.reduce(
        (sum: number, p: any) =>
          sum +
          (Number(p.NoOfLicense) || 0) +
          (Number(p.NoOfProductLicense) || 0),
        0,
      );

      if (totalLicenses > this.MAX_TRIAL_INSTRUMENTS) {
        Swal.fire({
          icon: "warning",
          title: "Limit Exceeded",
          text: `Trial license allows maximum ${this.MAX_TRIAL_INSTRUMENTS} instruments.`,
          confirmButtonText: "Ok",
          confirmButtonColor: "#FFCA28",
        });
        return; // stop save
      }
    }

    if (this.syncITLicenseForm.valid) {
      this.appLoader.open();
      const formValue = this.syncITLicenseForm.getRawValue();
      this.licenseService
        .addBillingShippingDetailsSyncIT(this.billingShippingDetail)
        .subscribe((data) => {
          if (!data.IsError && data.DataObject != null) {
            const payload = {
              CustomerId: data.DataObject.CustomerId,
              ShippingAddressId: data.DataObject.ShippingAddressId,
              NoOfMonths: formValue.NoOfMonths,
              SalesOrderNo: formValue.SalesOrderNo,
              PurchaseDate: formValue.PurchaseDate,
              SyncItProductLicenseId: this.SyncITProductLicenseId,

              deviceDetails: formValue.Products.filter(
                (p) => p.NoOfLicense > 0,
              ).map((p) => ({
                SyncItProductId: p.ProductId,
                NoOfProductLicense: p.NoOfLicense,
              })),
            };

            this.licenseService.addMoreSyncItLicense(payload).subscribe({
              next: (res) => {
                if (!res.IsError) {
                  this.appLoader.close();
                  this.dialogRef.close(res.DataObject);
                  this.snackBar.open("License saved successfully", "", {
                    duration: 3000,
                  });
                  this.errorMessage = "";
                  this.appLoader.close();
                } else {
                  this.appLoader.close();
                  this.errorMessage = res.Error;
                  Swal.fire({
                    icon: "warning",
                    title: "Trial License Exists",
                    text: res.Error,
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFCA28",
                  });
                }
              },
              error: (err) => {
                this.appLoader.close();
                this.errorMessage = "Something went wrong.";
              },
            });
          }
        });
    }
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  get isSaveDisabled(): boolean {
    if (!this.syncITLicenseForm) return true;

    // If form invalid → Disable Save
    if (!this.syncITLicenseForm.valid) return true;

    // const hasSelectedProduct = this.productsFormArray.controls.some(
    //   (c) => Number(c.value.NoOfLicense) > 0
    // );

    if (!this.isBillingShippingDetailFetched) return true;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/syncit/popup/addmore-syncit-license/addmore-syncit-license.component.ts